import { render, staticRenderFns } from "./ParticipantsModal.vue?vue&type=template&id=4e90a687&scoped=true"
import script from "./ParticipantsModal.vue?vue&type=script&lang=js"
export * from "./ParticipantsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e90a687",
  null
  
)

export default component.exports